// extracted by mini-css-extract-plugin
module.exports = {"markitingLabel":"MarkitingLabel-module__markitingLabel"};